<template>
  <index-main></index-main>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/formstyle";
</style>

<script>
  import IndexMain from './IndexMain.vue'

  export default {
    name: 'reset-phone-pwd-box',
    components: {
      IndexMain
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?28dc124b